module.exports = __webpack_public_path__ + "static/media/IE3@2x.584d8937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/IE/IE3@2x.png
// module id = 657
// module chunks = 0